import * as React from 'react';
import { GeneralViewPortWrapper, Wrapper } from './GeneralViewPortStyles';
import { language } from './GeneralViewPortLanguage';
import { PersistantHeaderLayout } from '../PersistantHeader/PersistantHeaderLayout';
import {FooterLayout, Props as FooterProps} from "../Footer/FooterLayout";

export type Props = {
	internalJSX: React.ReactNode;
};

export const GeneralViewPortLayout = (props: Props) => {
	const footerProps: FooterProps = {
		naked: false,
		mobile: false
	}
	const render = () => {
		const returnValue = (
			<GeneralViewPortWrapper>
				<PersistantHeaderLayout />
				<Wrapper>
					{props.internalJSX}
				</Wrapper>
				<FooterLayout {...footerProps} />
			</GeneralViewPortWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
